import { ArrowUpRight, ArrowDownRight } from "lucide-react";

const TONES = {
  primary: { bg: "rgba(14, 124, 111, 0.08)",  fg: "#0E7C6F" },
  gold:    { bg: "rgba(218, 165, 32, 0.12)",  fg: "#B8860B" },
  emerald: { bg: "rgba(16, 185, 129, 0.10)",  fg: "#059669" },
  teal:    { bg: "rgba(20, 184, 166, 0.10)",  fg: "#0F766E" },
  rose:    { bg: "rgba(244, 63, 94, 0.10)",   fg: "#E11D48" },
  slate:   { bg: "rgba(100, 116, 139, 0.10)", fg: "#475569" },
};

/**
 * Kamelcloud-style StatCard — warm white surface, soft rounded corners,
 * green-tinted iconography, semi-bold Readex Pro display digits.
 */
export default function StatCard({
  icon: Icon, label, value, hint, accent = "primary", testId, trend,
}) {
  const t = TONES[accent] || TONES.primary;
  return (
    <div className="card-warm p-5 group" data-testid={testId}>
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0 flex-1">
          <div className="text-[11px] font-bold text-slate-500 tracking-[0.12em] uppercase mb-2.5">
            {label}
          </div>
          <div className="font-display text-[30px] leading-none font-bold text-slate-900 tabular-nums tracking-tight">
            {value ?? "—"}
          </div>
          {hint && (
            <div className="mt-2.5 text-[12px] text-slate-500 leading-relaxed">{hint}</div>
          )}
          {trend && (
            <div className={
              "mt-2.5 inline-flex items-center gap-1 text-[11.5px] font-semibold " +
              (trend.up ? "text-emerald-700" : "text-rose-700")
            }>
              {trend.up
                ? <ArrowUpRight className="h-3.5 w-3.5" strokeWidth={2} />
                : <ArrowDownRight className="h-3.5 w-3.5" strokeWidth={2} />}
              {trend.value}
              <span className="text-slate-400 font-normal ms-1">{trend.label}</span>
            </div>
          )}
        </div>
        {Icon && (
          <div
            className="h-11 w-11 rounded-xl flex items-center justify-center shrink-0 transition-transform duration-200 group-hover:scale-105"
            style={{ background: t.bg, color: t.fg }}
          >
            <Icon className="h-5 w-5" strokeWidth={1.75} />
          </div>
        )}
      </div>
    </div>
  );
}
